interface IProps {
  playingIcon?: string
  pausedIcon?: string
}

export function useGlobalPlayerStateIcon(props?: IProps) {
  const { playingIcon = 'i-cus--tad-play', pausedIcon = 'i-cus--tad-pause' } =
    props || {}
  const globalPlayer = useGlobalAudioPlayer()

  if (globalPlayer.resourceState === 'loading') {
    return {
      stateIcon: cls`i-cus--tad-loading animate-spin`,
    }
  }

  return {
    stateIcon: globalPlayer.playing ? pausedIcon : playingIcon,
  }
}
